import {React, useEffect, useState} from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import CheckIcon from "@material-ui/icons/Check";
import ListItemText from "@material-ui/core/ListItemText";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import { Link } from "./../util/router";
import { useAuth } from "./../util/auth";
// import {getTrialUsage} from "./../util/db";
import { getTrialUsage } from "../util/apiHelpers";

const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(3),
  },
  price: {
    display: "flex",
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: "baseline",
  },
  listItem: {
    paddingTop: 2,
    paddingBottom: 2,
  },
  perkIcon: {
    minWidth: 34,
    color: theme.palette.success.main,
  },
}));

function PricingSection(props) {
  const classes = useStyles();
  const [noTrialsLeft, setNoTrialsLeft] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const auth = useAuth();

  useEffect(() => {
    async function checkTrial() {
      if (!auth?.user?.email) return;
      const trial = await getTrialUsage(auth?.user?.email);
      if (trial) {
        setNoTrialsLeft(true);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        return
      }
    }

    checkTrial();
  }, [auth?.user?.email]);

  const plans = [
    {
      id: "FREE TRIAL",
      name: "FREE TRIAL",
      price: "FREE 2 WEEK TRIAL",
      perks: [
        "Access to full showNAV administrative dashboard.",
        "Create and update unlimited show locations that populate to the users mobile apps.",
        "Auto generate direction pdfs.",
        "14 Day Trial. No Credit Card required.",
      ],
    },
    {
      id: "PAID",
      name: "PAID",
      price: "$500",
      perks: [
        "Access to full showNAV administrative dashboard.",
        "Create and update unlimited show locations that populate to the users mobile apps.",
        "Auto generate direction pdfs.",
        "Cancel anytime.",
      ],
    }
    // {
    //   id: "business",
    //   name: "Business",
    //   price: "50",
    //   perks: [
    //     "Lorem ipsum dolor sit amet",
    //     "Consectetur adipiscing elit",
    //     "Integer molestie lorem at massa",
    //     "Faucibus porta lacus fringilla vel",
    //     "Aenean sit amet erat nunc",
    //     "Lorem ipsum dolor sit amet",
    //     "Consectetur adipiscing elit",
    //   ],
    // },
  ];

  return (
    <Section
      bgColor={'transparent'}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container>
        <Grid container={true} justifyContent="center" spacing={4}>
          {plans.map((plan, index) => (
            <Grid item={true} xs={12} md={4} key={index}>
              <Card className={classes.card}>
                <CardContent className={classes.cardContent}>
                  {/* <Typography variant="h6" component="h2">
                    {plan.name}
                  </Typography> */}
                  <Box className={classes.price} mt={1}>
                    <Typography variant={plan.name ===`FREE TRIAL` ? "h5" : "h4"}>{plan.price}</Typography>
                    {plan.name !== 'FREE TRIAL' && <Typography variant="h4" color="textSecondary">
                      /week
                    </Typography>}
                  </Box>

                  {plan.description && (
                    <Box mt={2}>
                      <Typography component="p" color="textSecondary">
                        {plan.description}
                      </Typography>
                    </Box>
                  )}

                  {plan.perks && (
                    <Box mt={1}>
                      <List aria-label="perks">
                        {plan.perks.map((perk, index) => (
                          <ListItem
                            className={classes.listItem}
                            disableGutters={true}
                            key={index}
                          >
                            <ListItemIcon className={classes.perkIcon}>
                              <CheckIcon />
                            </ListItemIcon>
                            <ListItemText>{perk}</ListItemText>
                          </ListItem>
                        ))}
                      </List>
                    </Box>
                  )}

                  <Box mt="auto" pt={3}>
                    <Button
                      component={Link}
                      to={
                        auth.user
                          ? `/purchase/${plan.id}`
                          : `/auth/signup?next=/purchase/${plan.id}`
                      }
                      variant="contained"
                      color="primary"
                      size="large"
                      fullWidth={true}
                      disabled={plan.id === "FREE TRIAL" && (noTrialsLeft || isLoading)}
                    >
                      {isLoading ? "Checking trial status..." : (noTrialsLeft && plan.id === "FREE TRIAL") ? "NO TRIALS LEFT!" : (!noTrialsLeft && plan.id === "FREE TRIAL") ? "START TRIAL" : "SUBSCRIBE"}
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Section>
  );
}

export default PricingSection;
